// Panelden mobil uygulamaya anlık bildirim (API: POST push/send).
// Konu (topic): all | campaigns | recipes | products — kullanıcılar uygulamadaki
// "Bildirim ayarları"ndan hangi konuları alacaklarını seçer.
import axios from "axios";

const PUSH_URL = "https://buharaapi.stechomeyazilim.info/push/send";

export const sendPush = ({ title, body, topic = "all", type = "notifications", id = null, url = null }) =>
  axios
    .post(PUSH_URL, { title, body, topic, type, id, url }, { headers: { "X-Push-Key": process.env.REACT_APP_PUSH_KEY || "" } })
    .catch(e => console.log("push/send", e));

// Yeni tarif / ürün eklendiğinde otomatik bildirim. Pasif (taslak) kayıtlar için gönderilmez.
export const notifyNewContent = (kind, entity) => {
  if (!entity?.ID) return;
  if (kind === "recipe") {
    if (entity.Recipes_IsActive === false || entity.IsActive === false) return;
    sendPush({
      title: "Yeni tarif 🍽️",
      body: entity.Recipes_Title || "Buhara'da yeni bir tarif var!",
      topic: "recipes",
      type: "recipe",
      id: entity.ID,
    });
  } else if (kind === "product") {
    if (entity.Products_IsActive === false) return;
    sendPush({
      title: "Yeni ürün 🌶️",
      body: entity.Products_Name || "Buhara'da yeni bir ürün var!",
      topic: "products",
      type: "product",
      id: entity.ID,
    });
  }
};
